import { isEmpty, filter, flatMap } from 'lodash';
import React from 'react';
import { Table } from 'react-bootstrap';

const TableCommon = ({
  headerTables,
  dataSource,
}: {
  headerTables: any;
  dataSource: any;
}): JSX.Element => {
  const headerFields = flatMap(headerTables, ({ columns }) =>
    filter(columns, (column) => !!column.dataIndex),
  );

  return (
    <div>
      <Table className="table-campaign" bordered responsive>
        <thead>
          {headerTables.map((row: any, rIndex: number) => {
            return (
              <tr key={rIndex}>
                {row.columns.map((column: any, cIndex: number) => {
                  return (
                    <th
                      key={cIndex}
                      colSpan={column.colSpan}
                      rowSpan={column.rowSpan}
                      className={column.className}
                      style={{ width: column.width }}
                    >
                      {column.text}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody>
          {isEmpty(dataSource) ? (
            <td className="text-center" colSpan={headerFields?.length}>
              【登録されていません】
            </td>
          ) : (
            dataSource.map((row: any, rIndex: number) => {
              return (
                <tr key={rIndex}>
                  {headerFields.map((cell, cellIndex) => (
                    <td key={cellIndex}>
                      {cell.render
                        ? cell.render({ item: { ...row, rIndex }, dataIndex: cell.dataIndex })
                        : (row as any)[cell.dataIndex]}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default TableCommon;
